import { defineStore } from 'pinia'
import axios from 'crypto-fetch/axios'
import { getCasinoCache } from '@ms/components/games/useGamesCache'

export const useGameCardsStore = defineStore('gameCards', {
  state: () => ({
    gameCards: []
  }),
  actions: {
    async getGamesCards(bffRes) {
      try {
        if (bffRes) {
          this.gameCards = parseData(bffRes)
        } else {
          const data = await axios.get('/highfreq/games-lobby/game-cards')
          this.gameCards = parseData(data)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
})

const recentlyPlayed = (game) => {
  return (Date.now() - game.time) / 3600000 <= 168
}

const parseData = (data) => {
  const cacheData = getCasinoCache()
  if (cacheData && recentlyPlayed(cacheData[0])) {
    const index = data.findIndex((x) => x.gameName.toLowerCase() === cacheData[0].gameName)
    if (index !== -1) {
      const s = data.splice(index, 1)
      s.isRecently = true
      return [...s, ...data]
    } else {
      return data
    }
  } else {
    return data
  }
}
